import classNames from "classnames";
import Select, { SingleValue } from "react-select";
import "./searchableSelect.scss";
import { useInModal } from "../../elements/ModalContext";
import {
  SearchableSelectOption,
  SearchableSelectProps,
} from "./SearchableSelect.types";

/** A select filtered by typing into it, whose list opens as soon as it is focused. */
export function SearchableSelect({
  id,
  options,
  value,
  onChange,
  placeholder = "Please select",
  disabled = false,
  clearable = false,
  noOptionsMessage = "Nothing matches that.",
  className,
  menuPosition,
  ariaDescribedBy,
  ariaInvalid,
}: SearchableSelectProps) {
  const selected = options.find((option) => option.value === value) ?? null;
  const inModal = useInModal();
  // In a modal the menu is fixed, so it overlays the dialog rather than lengthening its
  // scrolling body. A fixed menu stays put while its container scrolls, so scrolling is held.
  const position = menuPosition ?? (inModal ? "fixed" : "absolute");
  const fixed = position === "fixed";

  return (
    <div className={classNames("form-control searchable_select", className)}>
      <Select<SearchableSelectOption, false>
        className="custom-select"
        classNamePrefix="select"
        inputId={id}
        options={options}
        value={selected}
        onChange={(option: SingleValue<SearchableSelectOption>) => {
          if (option) {
            onChange(option.value);
          } else if (clearable) {
            onChange("");
          }
        }}
        isDisabled={disabled}
        isClearable={clearable}
        isSearchable
        openMenuOnFocus
        placeholder={placeholder}
        noOptionsMessage={() => noOptionsMessage}
        menuPosition={position}
        menuShouldBlockScroll={fixed}
        aria-describedby={ariaDescribedBy}
        aria-invalid={ariaInvalid}
      />
    </div>
  );
}

export default SearchableSelect;
